
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TGenericObject } from '@/types/base'
@Component
export default class ShowcaseLinks extends Vue {
  @Prop({ required: true }) links: TGenericObject
  @Prop({ default: 'Further information' }) header: string
}
